import {VideoProps} from '../components/video-input';
export const getVideoInput =
  <T>(data: Omit<VideoProps, 'type'>) =>
  (): VideoProps => ({
    ...data,
    type: 'video-input',
  });
